import React, {useEffect, useState} from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Doughnut } from 'react-chartjs-2'
import colorChats from '../../lib/colorChats'

var tituloGrafico = ''

const mascaraLabel = (valor)=>{
  if(tituloGrafico === 'Atendimento por Quantidade'){
    return(valor);
  }else{
    return(parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}))
  }
}

const PizzaCard = ({ title, color, dados }) => {

  const [totalGrafico, setTotalGrafico] = useState(0);

  tituloGrafico = title;

  useEffect(()=>{
    let total = 0;
    if(dados.valores){
      dados.valores.forEach(valor=>{
        total += Number(valor)
      })

      if(title === "Atendimento por Quantidade"){
        total = 'Total: ' + total;
      }else{
        //total = 'R$ ' + total.toFixed(2);
        if(dados.total){
          total = parseFloat(dados.total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
        }else{
          total = parseFloat(total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
        }
      }

      setTotalGrafico(total);
    }
  },[]) // eslint-disable-line react-hooks/exhaustive-deps

  const options = {
    legend: {
      display: true,
      position: "left",
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 8,
        padding: 5,
      },
    },
    tooltips: {
      enabled: true,
      callbacks: {
        label: function(tooltipItem, data) {
          // var label = ''
          // var label = data.datasets[0].labels[tooltipItem.index] || '';
          var label = mascaraLabel(data.datasets[0].data[tooltipItem.index]);
          
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;

          // setTotalGrafico(total)

          var valor = dataset.data[tooltipItem.index];
          var porcentagem = parseFloat((valor/total*100).toFixed(1));
          label += ' ('+porcentagem+'%)';

          return label;
        },
        title: function(tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        },
        // afterLabel: function(tooltipItem, data) {
        //   console.log('teste after');
        //   var dataset = data.datasets[tooltipItem.datasetIndex];
        //   var meta = dataset._meta[Object.keys(dataset._meta)[0]];

        //   var percent = Math.round((dataset.data[tooltipItem.index] / meta.total) * 100)
        //   return '(' + percent + '%)';

        // },
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            display: false
          },
          gridLines: {
            drawBorder: false,
            zeroLineColor: "transparent",
            color: "rgba(255,255,255,0.05)"
          }
        }
      ],
      xAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(255,255,255,0.1)",
            zeroLineColor: "transparent"
          },
          ticks: {
            display: false
          }
        }
      ]
    },
    // onClick: (e, activeEls) => {function(tooltipItem, data) {
    // onClick: (event) => {

    //   console.log(event.chart);

    //   // let datasetindex = activeEls.datasets;
    //   // console.log(activeEls);
    //   // console.log(e);
    //   // let datasetIndex = activeEls[0].datasetIndex;
    //   // let dataIndex = activeEls[0].index;
    //   // let datasetLabel = e.chart.data.datasets[datasetIndex].label;
    //   // let value = e.chart.data.datasets[datasetIndex].data[dataIndex];
    //   // let label = e.chart.data.labels[dataIndex];
    //   // console.log("In click", datasetLabel, label, value);
    // }
  }

  const data = {
    labels: dados.lojas,
    datasets: [
      {
        labels: dados.lojas,
        pointRadius: "0",
        pointHoverRadius: "0",
        backgroundColor: colorChats.vivida,
        borderWidth: "0",
        data: dados.valores
      }
    ],
    hoverOffset: 10
  }

  return (
    <Card className='mb-0 mt-2'>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor">{totalGrafico}</div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Doughnut
          data={data}
          options={options}
          width={550}
          height={250}
        />
      </CardBody>
    </Card>
  )
}

export default PizzaCard